export default {
  title: {
    home: 'Home',
    notFound: 'Not found',
    error: 'Error',
    legal: 'Legal'
  },
  message: {
    generic: {
      loadingData: 'Loading data'
    }
  },
  language: {
    en: 'English',
    es: 'Spanish'
  },
  ui: {
    button: {
      btnBack: 'Back',
      btnSave: 'Save',
      btnCancel: 'Cancel',
      btnAccept: 'Accept',
      btnClose: 'Close',
      btnCreate: 'Create',
      btnConfirm: 'Confirm',
      btnChange: 'Change',
      btnDelete: 'Delete',
      btnRecord: 'Save',
      btnClear: 'Clear'
    },
    label: {},
    placeholder: {}
  },
  error: {
    undefined: 'Oops! Something went wrong!',
    notFound: "This page doesn't exist."
  },
  success: {},
  cookieLaw: {
    text:
      'We use our own and third-party cookies to perform usage analysis and measurement of our website to improve our services. If you continue browsing, we consider that you accept its use. You can change the settings or get more information here:',
    goToText: 'Cookies policy',
    buttonText: 'Accept'
  }
};
